import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`


    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Poppins';
        
    }


   .container {
    margin: 0 auto;
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
   }


`;

export default GlobalStyle;
